import { Link } from "react-router-dom";
import Seo from "../components/Seo";
import Icon from "../components/Icon";
import { vision, missions, commitment } from "../data/content";

const missionIcons = ["bulb", "handshake", "users", "globe", "leaf"];

export default function About() {
  return (
    <>
      <Seo path="/about" />

      <header className="page-hero">
        <div className="page-hero__bg">
          <img src="/images/truck-jakarta-overpass.jpg" alt="Freight truck operating under Jakarta's toll road overpass" />
        </div>
        <div className="container page-hero__inner">
          <span className="page-hero__crumb">
            <Link to="/">Home</Link> / About
          </span>
          <h1>About Us</h1>
          <p>
            Built on operational excellence and global connectivity, PT. Bumi Cakrawala
            Logistik helps businesses move goods, projects, and opportunities across
            borders with confidence.
          </p>
        </div>
      </header>

      <section className="section">
        <div className="container">
          <div className="vm">
            <div className="vm__vision">
              <span className="eyebrow">Our Vision</span>
              <h3 style={{ marginTop: 12 }}>
                Leading global <em>logistics</em> partner
              </h3>
              <p>{vision}</p>
            </div>
            <div className="vm__mission">
              <span className="eyebrow" style={{ color: "var(--orange-500)" }}>
                Our Mission
              </span>
              <h3 style={{ marginTop: 12 }}>
                How we <em>deliver</em>
              </h3>
              <ul>
                {missions.map((m, i) => (
                  <li key={i}>
                    <span className="vm__mission-icon">
                      <Icon name={missionIcons[i]} size={18} />
                    </span>
                    <p>{m}</p>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="section section--dark">
        <div className="container">
          <div className="quote-banner">
            <div className="quote-banner__media photo-panel photo-panel--diagonal">
              <img src="/images/port-sunset-dock.jpg" alt="Port dock and cranes at sunset" />
            </div>
            <div>
              <span className="eyebrow">Our Commitment</span>
              <blockquote>{commitment}</blockquote>
              <p className="lead" style={{ marginTop: 24 }}>
                Every shipment, every project, and every partnership is handled with the
                same standard of care — because logistics, done right, is what lets
                businesses focus on growth instead of friction.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="cta-banner">
            <h2>Want to know how we can support your supply chain?</h2>
            <Link to="/contact" className="btn btn-dark">
              Contact Our Team <Icon name="arrowRight" size={18} />
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
